import React, {useEffect, useState} from "react";
import {makeApiCall} from "../../Api/makeApiCall";
import Page from "../Components/Page";
import _ from "lodash";
import BucketPrice from "./BucketPrice";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import {GenericCostDisplay} from './GenericCostDisplay';
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";

const FILES = [
    {filePath: 'costs_by_service.jsonl', fileType: 'jsonl', header: 'Overall Service Cost', Component: GenericCostDisplay, extraHeader: []},
    {filePath: 'gcs_bucket.jsonl', header: 'Cloud Storage Cost by Bucket', Component: GenericCostDisplay, extraHeader: []},
    {filePath: 'gcs_bucket_and_description.jsonl', header: 'Cloud Storage Cost by Bucket + Cost Type', Component: GenericCostDisplay, extraHeader: []},
    {filePath: 'trino_cluster.jsonl', header: 'Trino Cluster vs Transient Dataproc', Component: GenericCostDisplay, extraHeader: []},
    {filePath: 'transient_clusters_by_dag.jsonl', header: 'Transient Cluster Cost by Dag', Component: GenericCostDisplay, extraHeader: []},
    {filePath: 'dataflow_by_dag.jsonl', header: 'Dataflow Cost By Dag', Component: GenericCostDisplay, extraHeader: []},
    {filePath: 'bigquery_costs_by_dag.jsonl', header: 'Bigquery Cost By Dag', Component: GenericCostDisplay, extraHeader: []},
    {filePath: 'checkpoint_bucket.json', header: 'Checkpoint Bucket Partitions', Component: BucketPrice},
    {filePath: 'data_bucket.json', header: 'Data Bucket Partitions', Component: BucketPrice},
    {filePath: 'data_test_bucket.json', header: 'Data Test Bucket Partitions', Component: BucketPrice},
    {filePath: 'tmp_bucket.json', header: 'Tmp Bucket Partitions', Component: BucketPrice},
    {filePath: 'nucleus_snowflake_costs.jsonl', header: 'Snowflake Costs', Component: GenericCostDisplay, extraHeader: []},
    {filePath: 'circana_cost.jsonl', header: 'Circana Costs', Component: GenericCostDisplay, extraHeader: []},
    {filePath: 'adp_private_cloud_cost.jsonl', header: 'ADP Costs', Component: GenericCostDisplay, extraHeader: [{header: 'Cost Category', accessorKey: 'cost_category', sticky: "left", size: 250, footer: () => <span>Totals</span>}]},
    {filePath: 'projections_cost.jsonl', header: 'Projections Costs', Component: GenericCostDisplay, extraHeader: [{header: 'Cost Category', accessorKey: 'cost_category', sticky: "left", size: 250, footer: () => <span>Totals</span>}]}
];

const CloudCostsPage = () => {
    const [costsResponse, setCostsResponse] = useState({});
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {
        const file = FILES[selectedIndex];
        if (!costsResponse[file.filePath]) {
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/cloudCosts/${file.filePath}`)
                .then(data => {
                    setCostsResponse(prev => ({...prev, [file.filePath]: data[file.filePath]}));
                });
        }
    }, [selectedIndex]);

    return (
        <Page name={<div><i className="fas fa-crown"/> Queen's Treasury <i className="fas fa-coins"/></div>} >
            <Tabs selectedIndex={selectedIndex} onSelect={index => setSelectedIndex(index)}>
                <TabList>
                    {
                        FILES.map(f => (
                            <Tab key={f.filePath}>
                                {f.header}
                            </Tab>
                        ))
                    }
                </TabList>
                {
                    FILES.map(({Component, header, filePath, extraHeader}) => (
                        <TabPanel key={filePath}>
                            <LoadingWrapper loading={_.isEmpty(costsResponse[filePath])}>
                                <Component filePath={filePath} fileContents={costsResponse[filePath]} header={header} extraHeader={extraHeader}/>
                            </LoadingWrapper>
                        </TabPanel>
                    ))
                }
            </Tabs>
        </Page>
    );
};

export default CloudCostsPage;
